(() => {
  const dialog = document.getElementById('blx-hand-promo');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'blx-hand-promo-seen-v1';
  try { if (sessionStorage.getItem(key)) return; } catch (_) { /* Still allow closing when storage is unavailable. */ }
  const started = Date.now();
  let shown = false, previousFocus, previousOverflow;
  function check() {
    if (shown || document.visibilityState !== 'visible') return;
    const banner = document.getElementById('shopify-pc__banner');
    if (banner && banner.getClientRects().length && getComputedStyle(banner).visibility !== 'hidden') return;
    if (document.querySelector('dialog[open], .blx-launch-menu[open]')) return;
    const y = window.scrollY;
    const range = document.documentElement.scrollHeight - window.innerHeight;
    const threshold = y >= 120 && (Date.now() - started >= 3000 || (range > 0 && y / range >= 0.25));
    if (!threshold) return;
    shown = true;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    try { sessionStorage.setItem(key, '1'); } catch (_) { /* No persisted state. */ }
    window.removeEventListener('scroll', check);
    document.removeEventListener('visibilitychange', check);
    clearInterval(timer);
  }
  dialog.querySelectorAll('.blx-promo-close, .blx-promo-later').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true});
  });
  window.addEventListener('scroll', check, {passive:true});
  document.addEventListener('visibilitychange', check);
  const timer = setInterval(check, 1000);
})();
